var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCadenas2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 275.5 385.6",
    style: {
      enableBackground: "new 0 0 275.5 385.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.4,129.1V69.3c0-38.2-31.1-69.3-69.3-69.3C99.9,0,68.9,31.1,68.9,69.3v59.3C27.7,152.4,0,197,0,247.8 c0,75.9,61.8,137.7,137.7,137.7c75.9,0,137.7-61.8,137.7-137.7C275.5,197.3,248.1,153.1,207.4,129.1z M78.9,69.3 c0-32.7,26.6-59.3,59.3-59.3s59.3,26.6,59.3,59.3v54.4c-18.1-8.7-38.3-13.6-59.7-13.6c-21.1,0-41,4.8-58.9,13.2V69.3z M137.7,375.6 C67.3,375.6,10,318.3,10,247.8s57.3-127.7,127.7-127.7c70.4,0,127.7,57.3,127.7,127.7S208.2,375.6,137.7,375.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.7,205.6c-23.3,0-42.3,19-42.3,42.3s19,42.3,42.3,42.3s42.3-19,42.3-42.3S161,205.6,137.7,205.6z  M137.7,280.1c-17.8,0-32.3-14.5-32.3-32.3s14.5-32.3,32.3-32.3S170,230,170,247.8S155.5,280.1,137.7,280.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadenas2);
export default __webpack_public_path__ + "static/media/Cadenas2.00143c1bb7953fde21e1ecf269999a98.svg";
export { ForwardRef as ReactComponent };